module.exports = __webpack_public_path__ + "bin/9f261231465bdc26bcf1aec6ae788652.otf";